import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Connect } from './NotificationMenuContainer';
import { changeFavicon } from '../../../../utils/faviconUtils';

type Props = {
  isNew: boolean;
};

export class RawNotificationMenu extends React.Component<Props> {
  render() {
    const { isNew } = this.props;
    changeFavicon(isNew);
    return (
      <span>
        <FormattedMessage id="app.ui.navbar.alerts" />
        {isNew && (
          <span
            data-test-id="new-notification-menu"
            className="notification-menu__new"
          />
        )}
      </span>
    );
  }
}

export const NotificationMenu = Connect(RawNotificationMenu);
